(function () {
  angular.module("akitabox.desktop.directives.pinValueList", [
    "akitabox.core.pinValue",
    "akitabox.core.services.asset",
    "akitabox.core.services.pinValue",
    "akitabox.core.services.room",
    "akitabox.core.services.flag",
  ]);
})();
